<!-- e4e web pages -->
<template>
  <div>
    <nav class="nav-row">

      <img src="../assets/ehealth-logo.png" />
    
      <div class="search-container">
        <b-input-group size="lg" prepend="$" append=".00">
    <b-form-input></b-form-input>
  </b-input-group>
        <input v-model="searchQuery" class="input-search" placeholder="Search by name" />
      </div>

    </nav>
    <div class="pagination">
      <button class="btn1" @click="prevPage" :disabled="currentPage === 1">Previous</button>
      <span>{{ currentPage }} / {{ totalPages }}</span>
      <button class="btn1" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
    </div>
    <h3 class="centered-text text1">All Products</h3>
    <div class="product-card" v-for="(project, key) in paginatedProjects" :key="key">
      <div class="text1">{{ project.name }}</div>
      <div class="text2">{{ project.description }}</div>
      <div>
        <a v-for="(link, linkKey) in project.links" :key="linkKey" :href="link.url" target=”_blank”>
          <button class="btn1">{{ link.name }}</button>
        </a>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      projects: {
        project1: {
          name: "MSDAT Platform",
          description: "The Multi-Source Data Analytics and Triangulation (MSDAT) platform presents an analysis of key health indicators from multiple health data sources using interactive and intuitive visualizations.",
          links: {
            link1: {
              name: "Health Outcomes",
              url: "https://msdat.fmohconnect.gov.ng/dashboard/Health_Outcomes_and_Service_Coverage"
            },
            // link2: {
            //   name: "Mobile Link",
            //   url: "https://www.clarify.org"
            // },
            link3: {
              name: "Health Service",
              url: "https://msdat.fmohconnect.gov.ng/dashboard/Health_Service_Access"
            },
            link4: {
              name: "Demographics",
              url: "https://msdat.fmohconnect.gov.ng/dashboard/Demographics"
            },
            link5: {
              name: "Health Facility",
              url: "https://msdat.fmohconnect.gov.ng/dashboard/Health_Facility"
            },
            link6: {
              name: "Health Finance",
              url: "https://msdat.fmohconnect.gov.ng/dashboard/Health_Financing"
            },
            link7: {
              name: "Health Workforce",
              url: "https://msdat.fmohconnect.gov.ng/dashboard/Health_Workforce"
            },
            link8: {
              name: "Custom Dashboard",
              url: "https://msdat.fmohconnect.gov.ng/custom"
            },
            link9: {
              name: "Health Profile",
              url: "https://msdat.fmohconnect.gov.ng/health-profiles"
            },
            link10: {
              name: "NCDC",
              url: "https://msdat.fmohconnect.gov.ng/external-ncdc"
            },
            link11: {
              name: "Staging Link 1",
              url: "https://www.clarify.org"
            },
      
        


          }
        },
        project2: {
          name: "APHAN",
          description: "An online community of public health experts, researchers, students and other enthusiasts interested in health data and it's use",
          links: {
            link1: {
              name: "Production Link",
              url: "https://aphan.africa"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://staging.aphan.africa"
            }
          }
        },

        project3: {
          name: "e4e DHIS2 application",
          description: "DHIS2 Mobile Sync is a user-friendly mobile application that can function optimally both offline and online. The application is compatible with DHIS2 and can sync DHIS2 data, metadata and configuration.",
          links: {
            link1: {
              name: "Staging Link 1",
              url: "https://www.clarify.org"
            },
            link2: {
              name: "Staging Link 2",
              url: "https://www.clarify.org"
            }
          }
        },

        project4: {
          name: "FMoH-ISS",
          description: "The Federal Ministry of Health (FMOH)  has adopted the use of Information Communications Technology (Digital ISS Platform).",
          links: {
            link1: {
              name: "Production Link",
              url: "https://iss.fmohconnect.gov.ng"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://fmohiss.e4eweb.space"
            }
          }
        },

        project5: {
          name: "E4e Website",
          description: "This project is the center of eHealth4everyone's online presence. Details about who we are, what we do and what we have done are captured on the platform",
          links: {
            link1: {
              name: "Production Link",
              url: "https://ehealth4everyone.com"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://ehealth4everyone.com/e4etest"
            }
          }
        },


        project6: {
          name: "Medinstance",
          description: "A seamless service platform which allows a user to set up and host an OpenMRS instance in quick time with a hassle free deployment process.",
          links: {
            link1: {
              name: "Production Link",
              url: "https://medinstance.com"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://staging.medinstance.com"
            }
          }
        },


        project8: {
          name: "Carekojo",
          description: "Online Appointment Scheduler that will help the general public view and book medical appointments from the comfort of their homes and also derive some medical services.",
          links: {
            link1: {
              name: "Staging Link",
              url: "https://carekojo.e4eweb.space"
            }
          }
        },
        project9: {
          name: "Smartacare",
          description: "An Electronic Medical Record platform to cover the critical requirements of the hospital’s day-to-day activities which would achieve the most suitable provision for patient care.",
          links: {
            link1: {
              name: "Production Link",
              url: "https://smartacare.com"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://demo.smartacare.com"
            }
          }
        },
        project10: {
          name: "Datakojo",
          description: "Capture quality evidence that allows analysis to lead to the formulation of convincing and credible answers to the questions that have been posed",
          links: {
            link1: {
              name: "Production Link",
              url: "https://datakojo.com"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://staging.datakojo.com"
            }
          }
        },
        project11: {
          name: "Dhistance",
          description: "Dhistance is the world's first fully automated DHIS2 hosting and server management service. The application allows user sets up their DHIS2",
          links: {
            link1: {
              name: "Production Link",
              url: "https://dhistance.com"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://dhistance.com"
            }
          }
        },
        project12: {
          name: "DMI",
          description: "DMI is the acronym for Data Management Interface. It is a product designed to support the management of accurate health and meta-data on the MSDAT (Multi-Source Data Analysis and Triangulation) dashboard.",
          links: {
            link1: {
              name: "Production Link",
              url: "https://dmi.fmohconnect.gov.ng"
            },
            link2: {
              name: "Staging Link 1",
              url: "http://208.87.128.22:8980/login"
            }
          }
        },
        project13: {
          name: "Healththink Blog",
          description: "Healththink is a platform focused on collecting and simplifying health data for individuals and organizations. It was born out of the need to address the challenges of data availability and access",
          links: {
            link1: {
              name: "Production Link",
              url: "https://healththink.org"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://healththink.ehealth4.us"
            }
          }
        },
        // project14: {
        //   name: "Project NewViz",
        //   description: "The project involves researching new ways to visualise data effectively and making data consumable for decision-makers by producing effect storytelling animations using our already available data.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        project15: {
          name: "Healththink Database",
          description: "Healththink is a platform focused on collecting and simplifying health data for individuals and organizations. It was born out of the need to address the challenges of data availability and accessibility in Nigeria.",
          links: {
            link1: {
              name: "Staging Link 1",
              url: "http://172.93.48.4:8991/"
            }
          }
        },
        project16: {
          name: "HPPDM",
          description: "This project is part of the DACISSH project. PDM maps health project and data activities in Nigeria. The Inventory dashboard provides detailed visualizations of the partner data mapping activities.",
          links: {
            link1: {
              name: "Production Link",
              url: "https://mapping.fmohconnect.gov.ng"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://mapping.e4eweb.space"
            }
          }
        },
        // project17: {
        //   name: "Manual Data Population",
        //   description: "This project is part of the DACISSH project. PDM maps health project and data activities in Nigeria. The Inventory dashboard provides detailed visualizations of the partner data mapping activities.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        // project18: {
        //   name: "NMDR",
        //   description: "This project is is to provide integrated malaria data analysis and automated generation of customized outputs & timely reports for program management, monitoring and evaluation.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        // project19: {
        //   name: "OpenHisa",
        //   description: "Open Health Insurance Systam and Analytics (OpenHISA) is a robust information system built to capture, collate and aggregate health insurance program data in a manner that enables analysis of trends and insight.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        // project20: {
        //   name: "Project Context",
        //   description: "This product is to be a web based platform that visualizes quantitative health data and provides qualitative data to interpret the visualized quantitative data.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        project21: {
          name: "SL-LMIS",
          description: "The Clinton Health Access Initiative (CHAI) team in Sierra Leone is working to ensure that a well-functioning logistics management information system (LMIS) exists for the Ministry of Health and Sanitation (MoHS).",
          links: {
            link1: {
              name: "Staging Link 1",
              url: "https://www.clarify.org"
            },
            link2: {
              name: "Staging Link 2",
              url: "https://www.clarify.org"
            }
          }
        },
        project22: {
          name: "BG-HIS",
          description: "Bangladesh Health Information System Advisory, The primary objective of the project is to support the Ministry of Health and Social Welfare (MOHFW) in strengthening the quality of its routinely reported administrative data.",
          links: {
            link1: {
              name: "Staging Link 1",
              url: "https://www.clarify.org"
            },
            link2: {
              name: "Staging Link 2",
              url: "https://www.clarify.org"
            }
          }
        },
        project23: {
          name: "Innovation Scaling",
          description: "The Integrated platform to support Scaling up Health Innovations in the African Region is developed by WHO AFRO. It is an Innovation Initiative to spearhead harnessing and fostering development of health innovations.",
          links: {
            link1: {
              name: "Staging Link 1",
              url: "http://209.182.234.132:3939/"
            }
          }
        },
        project24: {
          name: "WHO MPD-4-QED",
          description: "The World Health Organization (WHO) Maternal and Perinatal Database for Quality, Equity and Dignity Programme aims to establish an Electronic Database system in a nationwide network of referral level hospitals.",
          links: {
            link1: {
              name: "Production Link",
              url: "https://mpd4qed.org "
            },
            link2: {
              name: "Staging Link 1",
              url: "https://staging.mpd4qed.org"
            }
          }
        },
        project25: {
          name: "BHCPF",
          description: "The new National Health Act in Nigeria aims to substantially increase revenue and improve Primary Health Care (PHC) services through the Basic Health Care Provision Fund (BHCPF).",
          links: {
            link1: {
              name: "Production Link",
              url: "http://209.182.232.228:7654/"
            },
            link2: {
              name: "Staging Link 1",
              url: "http://192.168.5.123:9090"
            }
          }
        },
        // project26: {
        //   name: "Kaduna RMNCH Dashboard",
        //   description: "To develop a concise, simple, comprehensive, and interactive data visualization dashboard which is interoperable with DHIS2 and will give insights into all indicators of interest in the RMNCH+N thematic area.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        // project27: {
        //   name: "Knowledge management platform",
        //   description: "The digital library is a knowledge management platform containing historical and practical resources including templates and archives for memos, reports, letters, job aids, policy papers, and other important documents.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        // project28: {
        //   name: "External Dashboards",
        //   description: "This project is linked to DACISSH it involves the visualization of requested data for the use of the ministry of health and their partners.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        project29: {
          name: "FMoH ISS",
          description: "FMOH through the Monitoring and Evaluation (M&E) Division of the Department for Health Planning, Research and Statistics has adopted the use of Information Communications Technology (Digital ISS Platform).",
          links: {
            link1: {
              name: "Production Link",
              url: "https://iss.fmohconnect.gov.ng"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://fmohiss.e4eweb.space"
            }
          }
        },
        // project30: {
        //   name: "Ondo-GANCI",
        //   description: "Ondo Get All Newborn and Children Immunized (ONDOGANCI) is a mobile health application that is being designed as a tool in the improvement of immunization services delivery and uptake in Ondo state, Nigeria.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        project31: {
          name: "OHCSF",
          description: "The OHCSF recruitment waiver platform aims to digitize and manage the existing recruitment process in the Federal Civil Service to improve the transparency of the system.",
          links: {
            link1: {
              name: "Staging Link 1",
              url: "http://217.79.255.29:9346/login/?next=/"
            }
          }
        },
        project32: {
          name: "FMoH QoC Learning Platform (IHI)",
          description: "The primary mission of this project is the development, design, and launch of a new online learning platform (website) to strengthen the rollout of the National Quality of Care (QoC) Strategy at the state level",
          links: {
            link1: {
              name: "Production Link",
              url: "https://ihi.ehealth4everyone.com/"
            },

          }
        },
        project33: {
          name: "APHRC",
          description: "Development of a monitoring and evaluation web platform for internal KPIs and organization projects",
          links: {
            link1: {
              name: "Production Link",
              url: "https://melportal.aphrc.org"
            },
            link2: {
              name: "Staging Link 1",
              url: "https://aphrc.e4eweb.space/"
            }
          }
        },
        // project34: {
        //   name: "Country Baseline Assessment (ITES-BPO) Industry",
        //   description: "The project aimed to assess the global BPO marketplace, carrying out stakeholder analysis of the Nigerian and global environments with an outlook to unveil opportunities, bottlenecks and gaps.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        project35: {
          name: "Virtual Reality (vENC)",
          description: "The Virtual Essential Newborn Care is A mobile phone virtual reality simulation of the care provided to new borns based on identified signs",
          links: {
            link1: {
              name: "Production Link",
              url: "https://sites.uw.edu/virtualenc/"
            },
          }
        },
        // project36: {
        //   name: "Virtual Reality (Phobia App)",
        //   description: "It is conceived as a self-guided, stand-alone treatment modality for treating common phobias, particularly acrophobia, hydrophobia, herpetophobia, agoraphobia, and claustrophobia.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },
        // project37: {
        //   name: "EMID",
        //   description: "The EMID platform which uses the DHIS2 data management system consists of a public registration platform, a verification system and a mobile application.",
        //   links: {
        //     link1: {
        //       name: "Staging Link 1",
        //       url: "https://www.clarify.org"
        //     },
        //     link2: {
        //       name: "Staging Link 2",
        //       url: "https://www.clarify.org"
        //     }
        //   }
        // },

      },
      itemsPerPage: 5,
      currentPage: 1,
      searchQuery: '',
    };
  },
  computed: {
    filteredProjects() {
      const searchLower = this.searchQuery.toLowerCase();
      return Object.values(this.projects).filter(
        project => project.name.toLowerCase().includes(searchLower)
      );
    },
    totalPages() {
      return Math.ceil(this.filteredProjects.length / this.itemsPerPage);
    },
    paginatedProjects() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredProjects.slice(startIndex, endIndex);
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
  },
};
</script>

<style scoped>
@import '../../node_modules/@fontsource/roboto/index.css';

*{
  font-family: 'Roboto', sans-serif;
}

.nav-row{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
}

.input-search{
  padding: 20px;
  border-radius: 15px;
}
.product-card {
  border: 2px solid #D9D9D9;
  padding: 20px;
  margin: 20px;
}

.search-container {
  position: relative;
}

.search-container input {
  padding-right: 30px; /* Adjust padding to make room for the icon */
}

.search-container i {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #555; /* Adjust icon color as needed */
  cursor: pointer;
  font-size: 18px;
}

.centered-text {
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px; /* Adjust margin as needed */
}
.btn1{
  background-color: #748E32;
  color: white;
  padding: 15px;
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 8px;
  font-size: 18px;
  border: none;
  font-weight: 600;
  font-size: 20px;
  cursor: pointer;

}

.text1{
font-size: 32px;
font-weight: 700;
margin: 15px;
}

.text2{
  font-size: 20px;
  font-weight: 200;
  margin: 15px;
  color: rgb(62, 62, 62);
}

</style>
